// src/services/mrnEdit.js
//
// The patient page's admin-only MRN edit (both stores since 2026-10-29: RegX
// consents/duplicates, and Dubois's Google Sheet via updateSheetPatientMrn).
// Pure, so mrnEdit.test.js runs without Firebase.
//
//   - mrnChanged: did the admin actually change it (spaces ignored)?
//   - otherPatientsWithMrn: who ELSE already has this MRN, by the shared
//     same-MRN rule (sameMrnNumber: leading zeros ignored). A warning only;
//     the admin can save anyway (decided 2026-10-29).
//   - mrnChangeAudit: the MRN_CHANGED audit change, last 4 digits only (audit
//     events never hold a full MRN).

import { sameMrnNumber } from "./patientDuplicateMatch";

const str = (v) => (v === undefined || v === null ? "" : String(v).trim());
// Same as patientAuditService's getMrnLast4, kept here so this file stays
// Firebase-free (that module imports the Firebase app).
const last4 = (s) => (s.length >= 4 ? s.slice(-4) : s);

export const mrnChanged = (from, to) => str(from) !== str(to);

/**
 * @param {string} mrn the new MRN
 * @param {Array<{id, source, mrn}>} candidates from loadDuplicateCandidates
 * @param {{id: string, source: string}} self the patient being edited; a
 *   Firestore patient is excluded from both consents and duplicates (one record).
 */
export const otherPatientsWithMrn = (mrn, candidates = [], self = {}) => {
  if (!str(mrn)) return [];
  const selfIsSheet = self.source === "sheet";
  return candidates.filter((c) => {
    if (!c || !c.mrn || !sameMrnNumber(c.mrn, mrn)) return false;
    const cIsSheet = c.source === "sheet";
    return !(String(c.id) === String(self.id) && cIsSheet === selfIsSheet);
  });
};

export const mrnChangeAudit = (from, to) => ({
  field: "mrn",
  from: str(from) ? `…${last4(str(from))}` : null,
  to: str(to) ? `…${last4(str(to))}` : null,
});
